import React from "react"
import logo from '../assets/VEYONTA LOGO.pdf.png';

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current">
    <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06C2 17.08 5.66 21.25 10.44 22v-7.03H7.9v-2.91h2.54V9.85c0-2.52 1.49-3.91 3.77-3.91 1.09 0 2.23.2 2.23.2v2.47h-1.26c-1.24 0-1.63.78-1.63 1.57v1.88h2.78l-.44 2.91h-2.34V22C18.34 21.25 22 17.08 22 12.06Z" />
  </svg>
)

const TwitterIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current">
    <path d="M22 5.92c-.74.33-1.54.55-2.38.65a4.16 4.16 0 0 0 1.82-2.3 8.28 8.28 0 0 1-2.63 1.01A4.13 4.13 0 0 0 11.66 8.1c0 .32.04.64.1.94A11.72 11.72 0 0 1 3.25 4.7a4.15 4.15 0 0 0 1.28 5.53 4.08 4.08 0 0 1-1.87-.52v.05a4.14 4.14 0 0 0 3.31 4.06 4.22 4.22 0 0 1-1.86.07 4.14 4.14 0 0 0 3.86 2.88A8.3 8.3 0 0 1 2 18.45a11.7 11.7 0 0 0 6.35 1.87c7.62 0 11.79-6.35 11.79-11.86v-.54A8.45 8.45 0 0 0 22 5.92Z" />
  </svg>
)

const YoutubeIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current">
    <path d="M21.58 7.19a2.7 2.7 0 0 0-1.9-1.91C18 4.83 12 4.83 12 4.83s-6 0-7.68.45a2.7 2.7 0 0 0-1.9 1.91A28.2 28.2 0 0 0 2 12a28.2 28.2 0 0 0 .42 4.81 2.7 2.7 0 0 0 1.9 1.91c1.68.45 7.68.45 7.68.45s6 0 7.68-.45a2.7 2.7 0 0 0 1.9-1.91A28.2 28.2 0 0 0 22 12a28.2 28.2 0 0 0-.42-4.81ZM10 15.17V8.83L15.2 12 10 15.17Z" />
  </svg>
)

export default function Footer() {
  return (
    <footer className="bg-[#30251f] px-4 py-8 text-white sm:px-6 lg:px-8">
      <div className="mx-auto max-w-[1320px]">
        <div className="grid gap-10 py-6 md:grid-cols-[1.6fr_0.8fr_0.9fr] md:gap-16">
          <div>
            <div className="mb-7 inline-flex rounded-md bg-white px-5 py-3">
              <img
                src={logo}
                alt="Veyonta Track"
                className="h-16 w-auto object-contain"
              />
            </div>

            <p className="max-w-[380px] text-sm leading-relaxed text-white/80">
              Veyonta Track delivers smart automation, real-time tracking, and
              advanced camera solutions.
            </p>
          </div>

          <div>
            <h3 className="mb-5 text-sm font-bold text-white">Quick Links</h3>

            <ul className="space-y-4 text-sm text-white/75">
              <li>
                <a href="/contact" className="transition hover:text-[#ed860f]">
                  Contact
                </a>
              </li>

              <li>
                <a
                  href="/privacy-policy"
                  className="transition hover:text-[#ed860f]"
                >
                  Privacy policy
                </a>
              </li>

              <li>
                <a href="/faq" className="transition hover:text-[#ed860f]">
                  Faq
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-5 text-sm font-bold text-white">Address</h3>

            <p className="max-w-[230px] text-sm leading-relaxed text-white/75">
              C/O Guljharilal Sharma, Khajpur Bass, Islampur ,Jhujhunu- 333024, Rajasthan
            </p>
          </div>
        </div>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-md bg-[#ed860f] px-6 py-4 sm:flex-row sm:px-8">
          <p className="text-sm text-white">© 2025 All Rights Reserved.</p>

          <div className="flex items-center gap-4">
            <a
              href="#"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-[#1877f2]"
              aria-label="Facebook"
            >
              <FacebookIcon />
            </a>

            <a
              href="#"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-[#1da1f2]"
              aria-label="Twitter"
            >
              <TwitterIcon />
            </a>

            <a
              href="#"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-[#ff0000]"
              aria-label="Youtube"
            >
              <YoutubeIcon />
            </a>
          </div>
        </div>

        {/* <div className="mt-4 border-t border-white/20 pt-4 text-center">
          <p className="flex items-center justify-center gap-2 text-sm text-white/90">
            <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            Designed and developed by <span className="font-semibold">Indraq Innovations</span>
          </p>
        </div> */}
      </div>
    </footer>
  )
}